import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Field, arrayPush, arrayRemove} from 'redux-form'
import axios from 'axios';
import {default as DropzoneUpload} from 'react-dropzone';
import {locale} from '../locale/AppLocale';
import {Link} from 'react-router-dom'
import Config from '../Helpers/Config';
import {NotificationManager} from '../Helpers/NotificationManager';

import uniqueId from 'lodash/uniqueId'
import update from 'immutability-helper';
import * as authActions from '../actions/authActions'
import Loader from "./Loader";

const fileInput = ({input}) => {
    return <input type="hidden" name={input.name} value={input.value.name}/>
};

class DroppedFile extends Component {
    render() {

        let {file} = this.props;

        let progress = null
        if (file.is_queue) {
            progress =
                <div className="dz-progress">
                    <div ref={`dz-progress--bar`}
                         style={{width: (file.progress || 0) + `%`}}
                         className="dz-progress--bar">{(file.progress || 0) + `%`}</div>
                </div>
        }
        let error = null;
        if (file.is_valid !== true) {
            error = <div className="dz-error">{file.error}</div>
        }

        let actions = null
        if (!this.props.disabled) {
            actions = <div className="dz-actions">
                <button type="button" className="btn-1 btn--small btn--block" onClick={() => {
                    this.props.removeFile(file)
                }}>{locale.get('remove')}</button>
            </div>
        }

        let url = file.url
        if (file.preview) {
            url = file.preview
        }
        // is_queue
        // is_done
        // is_valid
        return (
            <div className={`dz-preview--item ${file.success ? 'success' : ''}`} onClick={(e) => e.stopPropagation()}>
                {progress}
                {error}
                <div className="dz-preview">
                    {
                        file.is_valid ? (file.is_queue && !file.is_done ? <Loader completed={file.is_done}/> : (
                            <Link to={url} target={`_blank`}>
                                <img width={80 + `px`} src={url} alt={file.name}/>
                            </Link>
                        )) : ''

                    }

                    {/*<Link to={url} target={`_blank`}>*/}
                    {/*    <img width={80 + `px`} src={url} alt={file.name}/>*/}
                    {/*</Link>*/}
                </div>
                <div className="dz-name">{file.name}</div>
                {actions}
            </div>
        )
    }
}

class DropZone extends Component {
    constructor(props) {

        super(props);

        let acceptFiles = props.accept || {
            'image/jpeg': ['.jpeg'],
            'image/png': ['.png'],
            'image/jpg': ['.jpg'],
        };

        this.state = {
            accept: acceptFiles,
            files: props.files || [],
            dropzoneActive: false,
            uploadProgress: {},
            queueLimit: props.queueLimit || 3,
        };

        this.onDrop = this.onDrop.bind(this);
        this.renderPreview = this.renderPreview.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.onUploadProgress = this.onUploadProgress.bind(this);
        this.onUploadSuccess = this.onUploadSuccess.bind(this);
        this.onDropRejected = this.onDropRejected.bind(this);

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.fields.getAll()) {
            let files = nextProps.fields.getAll().filter(fieldItem => {
                let index = this.state.files.findIndex(item => {
                    // console.log('item',item,fieldItem)
                    return item.path === fieldItem.path
                })
                return index === -1;
            });
            if (files.length) {
                this.setState({
                    files: [...this.state.files, ...files]
                })
            }
        }
    }


    onDrop(accepted, rejected) {

        let filesList = [];

        accepted.forEach((uploadedFile, index) => {
            let file = {
                id: uniqueId(),
                file: uploadedFile,
                name: uploadedFile.name,
                path: uploadedFile.name,
                is_queue: true,
                is_done: false,
                is_valid: true,
                progress: 15,
                preview: uploadedFile.preview
            };

            filesList.push(file);
            this.uploadFile(file)
        });

        rejected.forEach((uploadedFile, index) => {
            let file = {
                id: uniqueId(),
                is_queue: false,
                is_valid: false,
                name: uploadedFile.name,
                path: uploadedFile.name,
                progress: 0,
                file: uploadedFile,
                preview: uploadedFile.preview
            };
            filesList.push(file);
        });


        this.setState({
            files: [...this.state.files, ...filesList]
        });

    }

    onDropRejected(files) {
        files.forEach((file) => {
            NotificationManager.error(file.name, locale.get('cannot_upload_this_file'));
        });
    }

    onUploadProgress(file, progressEvent) {

        let index = this.findFileIndex(file)

        let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)

        this.updateFileByIndex(index, 'progress', progress)
    }

    findFileIndex(file) {
        return this.state.files.findIndex((fileItem) => fileItem.id === file.id)
    }

    updateFileByIndex(index, key, value) {
        return new Promise((resolve) => {
            this.setState({
                files: update(this.state.files, {
                        [index]: {
                            [key]: {
                                $set: value
                            }
                        }
                    }
                )
            }, () => {
                resolve(this.state.files[index]);
            })
        })
    }

    uploadFile(file) {

        let data = new FormData();
        let CancelToken = axios.CancelToken;
        let source = CancelToken.source();

        data.append('file', file.file);

        let config = {
            withCredentials: Config.withCredentials(),
            onUploadProgress: (progressEvent) => this.onUploadProgress(file, progressEvent),
            cancelToken: source.token
        };

        axios.post(Config.api() + 'upload-file', data, config)
            .then((response) => {
                if (!response.data.status || response.data.status !== true) {
                    return;
                }
                let uploadedFile = response.data.file;
                this.onUploadSuccess(file, uploadedFile);
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(error.message, file.name);
                }
                let index = this.findFileIndex(file)
                this.updateFileByIndex(index, 'is_valid', false)
                    .then(() => {
                        this.updateFileByIndex(index, 'error', error.message)
                    })
            });
    }


    async onUploadSuccess(file, uploadedFile) {
        let index = this.findFileIndex(file)
        await this.updateFileByIndex(index, 'is_done', true)
        await this.updateFileByIndex(index, 'success', true)
        await this.updateFileByIndex(index, 'path', uploadedFile.path)
        await this.updateFileByIndex(index, 'url', uploadedFile.url)
        await this.updateFileByIndex(index, 'fullUrl', uploadedFile.fullUrl)

        this.props.fields.push(uploadedFile);
    }

    removeFile(file) {

        if (confirm(locale.get('are_you_sure_to_delete_this_item')) === false) {
            return;
        }

        let index = this.findFileIndex(file)
        let array = this.state.files;

        array.splice(index, 1);
        this.setState({files: array});
        let deleteIndex = null;
        this.props.fields.forEach((item, index) => {
            if (this.props.fields.get(index).path === file.path) {
                deleteIndex = index
            }
        });

        if (!isNaN(parseInt(deleteIndex, 10))) {
            this.props.fields.remove(deleteIndex)
        }
    }

    renderPreview() {

        return (
            <div className="dz-preview-files">

                {this.state.files.map((file, index) => {

                    return (
                        <div
                            key={index}>
                            <DroppedFile
                                file={file}
                                disabled={this.props.disabled}
                                removeFile={this.removeFile}/>
                        </div>
                    )
                })}
            </div>);
    }


    render() {

        let view;
        if (this.props.disabled) {
            view = <div className="Dropzone-field--area">{this.renderPreview()}</div>
        } else {

            view = <DropzoneUpload onDrop={this.onDrop} onDropRejected={this.onDropRejected} accept={this.state.accept}>
                {({getRootProps, getInputProps}) => (
                    <section className={'Dropzone-field--area'}>
                        <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div className="dz-message">{locale.get('product_images')}</div>
                            {this.renderPreview()}
                        </div>

                    </section>
                )}
            </DropzoneUpload>

        }
        return (

            <div className={`input-c ` + (this.props.meta.touched && this.props.meta.error ? `has-error` : ``)}>
                {this.props.fields.map((member, index) => (
                    <Field
                        key={index}
                        name={`${member}`}
                        type="fileInput"
                        component={fileInput}
                    />
                ))}

                {this.props.label && this.props.label.length > 0 ? (
                    <label
                        className={'label '}>
                        {this.props.label}
                    </label>
                ) : ('')}


                <div className="input-type-wrapper">
                    <div className="Dropzone-field">
                        {view}
                    </div>
                </div>

                {this.props.meta.touched
                    && ((this.props.meta.error && <span className="help-block is-error">{this.props.meta.error}</span>)
                        || (this.props.meta.warning && <span>{this.props.meta.warning}</span>))}
            </div>
        );
    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {}
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch,
        changeField: (formName, field, value) => dispatch(arrayPush(formName, 'images', value)),
        arrayRemove: (formName, field, value) => dispatch(arrayRemove(formName, 'images', value)),
        requiresReLogin: () => dispatch(authActions.requiresRelogin())
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(DropZone);
